module.exports = __webpack_public_path__ + "img/20_48.ac80087f.png";